export default __webpack_public_path__ + "static/media/mini-6.cc823a58.jpg";